import React, { useEffect, useRef, useState } from 'react';
import '../../../Assets/Css/ViewEmpTask.scss';
import { connect } from 'react-redux';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Table from '../../../Components/Table';
import { LuPlusCircle } from "react-icons/lu";
import Select from 'react-select'
import { customStyle } from '../../../Components/Style'
import DatePicker from 'react-datepicker';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ImCheckmark } from "react-icons/im";
import { FaClipboard, FaClock, FaComment, FaCommentAlt, FaFile, FaList, FaPlayCircle } from "react-icons/fa";
import { BsPauseCircleFill } from "react-icons/bs";
import { FaStopCircle } from "react-icons/fa";
import { addSubTask, addTaskFiles, deleteSubTask, deleteTaskFiles, getSubTaskList, getTaskFiles, getTasks, updateSubTask, updateTask, updateTaskFiles } from '../../../Services/Task/action';
import UserAvatar from 'react-user-avatar';
import { getTimesheets } from '../../../Services/TimeSheet/action';
import { IoClose, IoTrash } from 'react-icons/io5';
import Pdf from '../../../Assets/Images/Employee/Pdf.svg';
import JPGIcon from '../../../Assets/Images/Employee/JPG Icon.svg';
import PNGIcon from '../../../Assets/Images/Employee/PNG Icon.svg';
import Modal from "react-bootstrap/Modal";
import Swal from 'sweetalert2';
import { getUsers } from '../../../Services/Users/action';
import useTimerStore from '../../../Lib/timerStore';
import { FaListCheck } from 'react-icons/fa6';
import { getTime } from '../../../Lib/utils';

const initialState = {
    title: '',
    assignto: null,
    description: '',
    startdate: null,
    enddate: null,
}

const ViewEmpTask = (props) => {
    const location = useLocation();
    const [data, setData] = useState({});
    const [activeTab, setActiveTab] = useState('files');
    const [inData, setInData] = useState([]);
    const [subTaskData, setSubTaskData] = useState([]);
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [clientData, setClientData] = useState(initialState);
    const [showInput, setShowInput] = useState(false);
    const [previews, setPreviews] = useState([]);
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [particularItem, setParticularItem] = useState({});
    const [show, setShow] = useState(false);
    const [taskStatus, setTaskStatus] = useState(data?.status);
    const [loading, setLoading] = useState({});
    const { start, pause, resume, stop, updateTimer } = useTimerStore();
    const fileInputRef = useRef(null);
    const navigate = useNavigate();

    // console.log("uploadedFiles ", uploadedFiles);
    console.log("files ", files);
    console.log("previews ", previews);

    const handleClose = () => {
        setShow(false);
    };
    const { id } = useParams();

    useEffect(() => {
        // props?.getTimesheets();
        props?.getTaskFiles();
        props?.getUsers({ module: 'users-names' });
        props?.getSubTaskList();
        props?.getTasks();
    }, [id])

    useEffect(() => {
        const updatedTask = props?.task?.find(item => item?.id == id);
        if (updatedTask) {
            const taskTimers = updatedTask?.taskTimerMap?.[0];
            const allTimers = updatedTask?.taskTimerMap;
            const actionHistory = typeof taskTimers?.action_history === "string"
                ? JSON.parse(taskTimers?.action_history)
                : taskTimers?.action_history || [];
            const { time, hoursLogged } = getTime(
                taskTimers?.start_time,
                taskTimers?.stop_time,
                actionHistory,
            )
            let totalElapsedTime = 0;
            allTimers?.forEach((timer) => {
                if (timer?.duration) {
                    const [hh, mm, ss] = timer?.duration?.split(/[hms\s]+/).filter(Boolean).map(Number);
                    totalElapsedTime += hh * 3600 + mm * 60 + ss;
                }
            });

            const totalH = Math.floor(totalElapsedTime / 3600);
            const totalM = Math.floor((totalElapsedTime % 3600) / 60);
            const totalS = totalElapsedTime % 60;
            const totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;
            setData(prev => {
                return {
                    ...prev,
                    ...updatedTask,
                    taskTimers: taskTimers,
                    totalHoursLogged: totalHoursLogged,
                    time: time
                };
            });
        }
    }, [props?.task, id]);

    let parentTask = null;
    if (data?.parent_task_id) {
        parentTask = props.task.find((task) => task.id === data.parent_task_id);
    }
    const taskTimers = parentTask?.taskTimerMap?.[0];
    const allTimers = parentTask?.taskTimerMap;

    useEffect(() => {
        if (!allTimers) return;

        allTimers.forEach((timer) => {
            // if (timer?.state !== "stopped") {
            const key = `${timer.employee_id}_${timer.task_id}`;
            useTimerStore.setState(state => ({
                timers: {
                    ...state.timers,
                    [key]: {
                        ...state.timers[key],
                        taskId: timer.task_id,
                        startTime: timer.start_time,
                        status: timer?.state,
                        actionHistory:
                            typeof timer.action_history === "string"
                                ? JSON.parse(timer.action_history)
                                : timer.action_history || [],
                    },
                },
            }));
            // }
        });
    }, [allTimers, id]);

    const actionHistory = typeof taskTimers?.action_history === "string"
        ? JSON.parse(taskTimers?.action_history)
        : taskTimers?.action_history || [];
    const { time, hoursLogged } = getTime(
        taskTimers?.start_time,
        taskTimers?.stop_time,
        actionHistory,
    )
    let totalElapsedTime = 0;
    allTimers?.forEach(async (timer) => {
        if (timer?.duration) {
            const [hh, mm, ss] = timer?.duration?.split(/[hms\s]+/).filter(Boolean).map(Number);
            totalElapsedTime += hh * 3600 + mm * 60 + ss;
        }
    });

    const totalH = Math.floor(totalElapsedTime / 3600);
    const totalM = Math.floor((totalElapsedTime % 3600) / 60);
    const totalS = totalElapsedTime % 60;
    const totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;

    const parentTaskStateData = {
        allData: {
            ...parentTask,
            taskTimers: taskTimers,
            totalHoursLogged: totalHoursLogged,
            time: time
        }
    }

    const header = [
        { field: 'Employee' },
        { field: 'Start Time' },
        { field: 'End Time' },
        { field: 'Memo' },
        { field: 'Hours Logged' },
    ];
    const subTaskHeader = [
        { field: 'Title' },
        { field: 'Employee' },
        { field: 'Start Date' },
        { field: 'Due Date' }
    ]

    const AssignTo = props?.users?.filter(item => data?.taskUserMap?.find(user => user?.userTaskMap?.id == item?.id))?.map((item) => ({
        label: item?.name,
        value: item?.id,
    }));

    let footer = true;
    let count = inData?.length;

    useEffect(() => {
        if (!props?.taskFiles) return;

        const filesData = [];
        props?.taskFiles?.filter(item => item?.task_id == data?.id)?.forEach((item) => {
            if (item?.file?.data && item?.file?.type === 'Buffer') {
                const byteArray = new Uint8Array(item.file.data);
                const stringData = new TextDecoder().decode(byteArray);

                let base64String = '';
                let mimeType = '';
                let fileName = item?.file_name || 'Unnamed File';

                if (stringData.startsWith('data:')) {
                    const match = stringData.match(/^data:(.*?);base64,(.*)$/);
                    if (match) {
                        mimeType = match[1];
                        base64String = match[2];
                    }
                } else {
                    mimeType = 'application/pdf';
                    base64String = btoa(String.fromCharCode(...byteArray));
                }

                try {
                    const binaryString = atob(base64String);
                    const len = binaryString.length;
                    const bytes = new Uint8Array(len);
                    for (let i = 0; i < len; i++) {
                        bytes[i] = binaryString.charCodeAt(i);
                    }

                    const blob = new Blob([bytes], { type: mimeType });
                    const url = URL.createObjectURL(blob);
                    filesData.push({
                        url,
                        mimeType,
                        ...item
                    });
                } catch (error) {
                    console.error('Error decoding base64 or creating blob:', error);
                }
            }
        });

        setUploadedFiles(filesData);
        return () => {
            filesData.forEach((item) => URL.revokeObjectURL(item?.url));
        };
    }, [props?.taskFiles]);

    // useEffect(() => {
    //     data?.timesheet?.length > 0
    //         ? setInData(
    //             data?.timesheet?.map((timesheet) => {
    //                 const allTimers = timesheet?.task?.taskTimerMap || [];
    //                 const taskDate = timesheet?.start_date?.split(' ')[0];

    //                 let totalElapsedTime = 0;
    //                 let totalHoursLogged;
    //                 allTimers.forEach((timer) => {
    //                     const timerDate = timer?.start_time?.split(' ')[0];
    //                     console.log('====================================');
    //                     console.log(timerDate, taskDate, timesheet?.start_time, timer?.start_time?.split(' ')[1]);
    //                     console.log('====================================');
    //                     if (timerDate === taskDate &&
    //                         (timesheet?.start_time == timer?.start_time?.split(' ')[1]) &&
    //                         timer?.start_time) {
    //                         if (timer?.duration && timesheet?.end_time) {

    //                             const [hh, mm, ss] = timer.duration
    //                                 .split(/[hms\s]+/)
    //                                 .filter(Boolean)
    //                                 .map(Number);
    //                             totalElapsedTime += (hh * 3600 + mm * 60 + ss);
    //                         } else {
    //                             const actionHistory = typeof timer.action_history === "string"
    //                                 ? JSON.parse(timer.action_history)
    //                                 : timer.action_history || [];

    //                             const seconds = calculateElapsedWithPauses(timer.start_time, actionHistory);
    //                             totalElapsedTime += seconds;
    //                         }
    //                     }
    //                 });


    //                 const totalH = Math.floor(totalElapsedTime / 3600);
    //                 const totalM = Math.floor((totalElapsedTime % 3600) / 60);
    //                 const totalS = totalElapsedTime % 60;
    //                 totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;

    //                 return {

    //                     "Employee": {
    //                         value: data?.taskUserMap?.filter((item) => item?.user_id)?.map((user) => ({
    //                             name: user?.userTaskMap?.name,
    //                             src: user?.userTaskMap?.profile_pic?.data ? `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(user?.userTaskMap?.profile_pic?.data)))}` : '',
    //                             id: user?.userTaskMap?.id,
    //                             isEmployeeTaskPage: false
    //                         })),
    //                         type: 'share holder',
    //                     },
    //                     "Start Time": {
    //                         value: timesheet?.start_time,
    //                         type: 'text',
    //                     },
    //                     "End Time": {
    //                         value: timesheet?.end_time,
    //                         type: 'text',
    //                     },
    //                     "Memo": {
    //                         value: timesheet?.memo,
    //                         type: 'text',
    //                     },
    //                     'Hours Logged': {
    //                         value: totalHoursLogged,
    //                         type: 'date',
    //                     },
    //                 };
    //             })
    //         )
    //         : setInData([]);
    // }, [data?.timesheet]);

    useEffect(() => {
        props?.subTask?.length > 0
            ? setSubTaskData(
                props?.subTask?.filter(item => item?.task_id == data?.id)?.map((item) => {
                    return {
                        "Title": {
                            value: item?.title,
                            type: 'text',
                        },
                        "Employee": {
                            value: item?.user?.name,
                            type: 'text',
                        },
                        "Start Date": {
                            value: item?.start_date?.split(' ')?.[0],
                            type: 'text',
                        },
                        "Due Date": {
                            value: item?.due_date?.split(' ')?.[0],
                            type: 'text',
                        },
                    };
                })
            )
            : setSubTaskData([]);
    }, [props?.subTask]);
    const showFields = () => setShowInput(true);
    const hideFields = () => setShowInput(false);


    const fileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        const newPreviews = newFiles.map(file => URL.createObjectURL(file));

        setFiles(prevFiles => [...prevFiles, ...newFiles]);
        setPreviews(prevPreviews => [...prevPreviews, ...newPreviews]);

        event.target.value = null;
    };

    useEffect(() => {
        return () => {
            previews.forEach(preview => URL.revokeObjectURL(preview));
        };
    }, [previews]);

    const handleRemoveFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
        setPreviews(previews.filter((_, i) => i !== index));
    };

    const fileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleChange = (e) => {
        if (e[1] == 'headerAll' && e[0] === true) {
            setTotalSelectedIds([...e[2]]);
        } else if (e[0] === true && e[1] !== 'headerAll') {
            setTotalSelectedIds([...totalSelectedIds, e[1]]);
        } else if (e[1] == 'headerAll' && e[0] === false) {
            setTotalSelectedIds([]);
        } else {
            let filterdId = totalSelectedIds.filter((item) => {
                return item != e[1];
            });
            setTotalSelectedIds(filterdId);
        }
    };

    const handleSubmit = async () => {
        try {
            const body = {
                title: clientData?.title,
                description: clientData?.description,
                start_date: clientData?.startdate,
                due_date: clientData?.enddate,
                employee_id: clientData?.assignto?.value,
                task_id: data?.id
            }
            await props?.addSubTask(body);
            setShowInput(false)
        } catch (error) {
            console.error("Error adding sub task :", error)
            toast.error(error?.response?.data?.message || "Something went wrong")
        }
    };

    const handleUpdateTaskStatus = async (newStatus) => {
        try {
            await props?.updateTask(data?.id, { status: newStatus }, true)
            setTaskStatus(newStatus);
        } catch (error) {
            console.error("Error updating task status:", error);
        }
    }


    const isTimerRunning = (assignedUserIds, currentUserRole, allTasks) => {

        const allRunningTimers = allTasks
            ?.flatMap(task => task?.taskTimerMap || [])
            ?.filter(timer => timer?.state !== "stopped");

        if (currentUserRole === "hr_senior") {
            return allRunningTimers.some(t => assignedUserIds?.includes(t?.employee_id));
        }

        return allRunningTimers.some(t => assignedUserIds?.includes(t?.employee_id) && t?.state != "stopped");
    };

    const handleUpdateTimer = async (status, timer) => {
        try {
            setLoading((prev) => ({ ...prev, [timer?.id]: true }))
            if (status === "startClicked") {
                const timerIsRunning = isTimerRunning([timer?.employee_id],
                    props?.user?.role?.name,
                    props?.task)
                if (timerIsRunning) {
                    toast.error("Timer is already running for a task.")
                    return;
                }
                const start_time = new Date();
                await props?.updateTask(timer?.id, { start_time, employee_id: timer?.employee_id, task_id: data?.id }, true);
                start(timer?.employee_id, data?.id);
                updateTimer(timer?.employee_id, data?.id);
            }
            else if (status === "pauseClicked") {
                const pause_time = new Date();
                await props?.updateTask(timer?.id, { pause_time, employee_id: timer?.employee_id, task_id: data?.id }, true)
                pause(timer?.employee_id, data?.id);
                updateTimer(timer?.employee_id, data?.id);
            }
            else if (status === "resumeClicked") {
                const resume_time = new Date();
                await props?.updateTask(timer?.id, { resume_time, employee_id: timer?.employee_id, task_id: data?.id }, true)
                resume(timer?.employee_id, data?.id);
                updateTimer(timer?.employee_id, data?.id);
            }
            else {
                stop(props?.updateTask, timer?.employee_id, timer?.id, data?.id);
                updateTimer(timer?.employee_id, data?.id);
            }
        } catch (error) {
            console.error("Error updating task timers:", error)
        }
        finally {
            setLoading((prev) => ({ ...prev, [timer?.id]: false }))
        }
    }

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleSaveFile = async () => {
        try {
            const base64File = await fileToBase64(files[0]);
            const body = {
                file: base64File,
                file_name: files[0].name,
                task_id: data?.id
            }
            await props?.addTaskFiles(body)
            setFiles([]);
            setPreviews([]);
        } catch (error) {
            console.error("Error updating task file:", error);
        }
    }

    const handleDeleteFile = async (item) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    Swal.fire('Deleted!', 'Your item has been deleted.', 'success');
                    await props?.deleteTaskFiles(item?.id)
                }
            });

        } catch (error) {
            console.error("Error deleting task file:", error);
        }
    }

    const content = <div className="viewEmpTask-main">
        <div className="page-title">
            <div className="page-title">
                <h4> Task Info </h4>
            </div>
            <div className="edit-btn">
                <button
                    type="submit"
                    className="custom-btn"
                    onClick={() => {
                        setData({})
                        navigate(-1)
                    }}
                >Cancel</button>
            </div>
        </div>
        <h4 className="task-title">{data?.title}</h4>

        <div className="content-part">
            <div className="row">
                <div className="col-lg-9">
                    <div className="left-part">
                        <div className="custom-row">
                            <div className="task-detail">
                                <div className="all-btn">
                                    {((props?.user?.role?.name == "hr_senior" ? true : data?.taskUserMap?.filter(item => item?.user_id == props?.user?.id)?.length > 0) && taskStatus !== "Completed") && (
                                        <button type="submit" className="custom-mark-btn" onClick={() => handleUpdateTaskStatus("Completed")}>
                                            {props.loading ? (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    className="custom-spinner"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                <div className='timer-content'>
                                                    <ImCheckmark className='me-2' /> Mark As Complete
                                                </div>
                                            )}
                                        </button>
                                    )}
                                    {((props?.user?.role?.name === "hr_senior" ||
                                        data?.taskUserMap?.some(item => item?.user_id === props?.user?.id)) &&
                                        taskStatus === "Completed") && (
                                            <button
                                                type="submit"
                                                className="custom-mark-btn"
                                                onClick={() => handleUpdateTaskStatus("Incomplete")}
                                            >
                                                {props.loading ? (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        className="custom-spinner"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                ) : (
                                                    <div className="timer-content">
                                                        <ImCheckmark className="me-2" /> Mark As Incomplete
                                                    </div>
                                                )}
                                            </button>
                                        )}

                                </div>
                                <h5 className="emptask-detail-divider" />
                                <div className="row">
                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Project</h6>
                                        </div>
                                        <div className="col-9">
                                            <h6 className="labels">{data?.project?.name || '--'}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Priority</h6>
                                        </div>
                                        <div className="col-9">
                                            <h6 className="labels">{data?.priority || '--'}</h6>
                                        </div>
                                    </div>



                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Assign To</h6>
                                        </div>
                                        {data?.taskUserMap?.length > 0 && data?.taskUserMap?.map((user, index) => {

                                            const profilePicSrc = `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(user?.userTaskMap?.profile_pic?.data)))}`;
                                            const timer = data?.taskTimerMap?.filter(item => item?.employee_id == user?.user_id && item?.task_id == data?.id && item?.state != "stopped");

                                            return (
                                                <div className="col-4" key={index}>
                                                    <div className="profile-section">
                                                        {user?.userTaskMap?.profile_pic ? (
                                                            <img
                                                                src={profilePicSrc}
                                                                alt="Profile Pic"
                                                                className="task-pic"
                                                            />
                                                        ) : (
                                                            <UserAvatar size="40" name={user?.userTaskMap?.name || 'U'} src={user?.userTaskMap?.src} className="task-pic" style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                                        )}

                                                        <div className="profile-info">
                                                            <h6 className="labels">{user?.userTaskMap?.name || '--'}</h6>
                                                            <h6 className="labels">{user?.userTaskMap?.designation?.name || '--'}</h6>
                                                        </div>
                                                        {(timer?.[0]?.employee_id == props?.user?.id ||
                                                            props?.user?.role?.name == "hr_senior"
                                                        ) && (
                                                                <>

                                                                    {(timer?.[0]?.state == "running" || timer?.[0]?.state == "resumed") &&
                                                                        <div>
                                                                            {loading[timer?.[0]?.id] ? (
                                                                                <Spinner
                                                                                    style={{
                                                                                        marginLeft: '20px'
                                                                                    }}
                                                                                    as="span"
                                                                                    animation="border"
                                                                                    className="custom-spinner"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            ) : (
                                                                                <div className='timer-content'>
                                                                                    <BsPauseCircleFill className='me-2' style={{
                                                                                        marginLeft: '20px',
                                                                                        color: '#5959fe',
                                                                                        cursor: 'pointer'
                                                                                    }} size={28} onClick={() => handleUpdateTimer("pauseClicked", timer?.[0])} />
                                                                                </div>
                                                                            )
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {(timer?.[0]?.state == "paused") &&
                                                                        <div>
                                                                            {loading[timer?.[0]?.id] ? (
                                                                                <Spinner
                                                                                    style={{
                                                                                        marginLeft: '20px'
                                                                                    }}
                                                                                    as="span"
                                                                                    animation="border"
                                                                                    className="custom-spinner"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            ) : (
                                                                                <div className='timer-content'>
                                                                                    <FaPlayCircle className='me-2' style={{
                                                                                        color: '#058C42',
                                                                                        cursor: 'pointer',
                                                                                        marginLeft: '20px'
                                                                                    }} size={28} onClick={() => handleUpdateTimer("resumeClicked", timer?.[0])} />
                                                                                </div>
                                                                            )
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {timer?.length > 0 && timer?.[0]?.state != "stopped" &&
                                                                        <div>
                                                                            {loading[timer?.[0]?.id] ? (
                                                                                <Spinner
                                                                                    style={{
                                                                                        marginLeft: '20px'
                                                                                    }}
                                                                                    as="span"
                                                                                    animation="border"
                                                                                    className="custom-spinner"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            ) : (
                                                                                <div className='timer-content'>
                                                                                    <FaStopCircle className='me-2' style={{
                                                                                        color: '#D30000',
                                                                                        cursor: 'pointer'
                                                                                    }} size={28} onClick={() => handleUpdateTimer("stopClicked", timer?.[0])} />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    }
                                                                    {(timer?.length == 0) &&
                                                                        <div>
                                                                            {loading[timer?.[0]?.id] ? (
                                                                                <Spinner
                                                                                    style={{
                                                                                        marginLeft: '20px'
                                                                                    }}
                                                                                    as="span"
                                                                                    animation="border"
                                                                                    className="custom-spinner"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            ) : (
                                                                                <div className='timer-content'>
                                                                                    <FaPlayCircle className='me-2' style={{
                                                                                        marginLeft: '20px',
                                                                                        color: '#058C42',
                                                                                        cursor: 'pointer'
                                                                                    }} size={28} onClick={() => handleUpdateTimer("startClicked", {
                                                                                        employee_id: user?.user_id
                                                                                    })} />
                                                                                </div>
                                                                            )
                                                                            }
                                                                        </div>
                                                                    }
                                                                </>
                                                            )}
                                                    </div>
                                                    {(timer?.[0]?.employee_id == props?.user?.id ||
                                                        props?.user?.role?.name == "hr_senior"
                                                    ) && (
                                                            <>
                                                                {(() => {
                                                                    if (timer?.length == 0) {
                                                                        return null;
                                                                    }
                                                                    let totalElapsed = 0;
                                                                    const history = typeof timer?.[0]?.action_history === 'string'
                                                                        ? JSON.parse(timer?.[0]?.action_history)
                                                                        : timer?.[0]?.action_history || [];

                                                                    for (let i = 0; i < history?.length; i++) {
                                                                        const action = history[i];
                                                                        const next = history[i + 1];

                                                                        if ((action?.action === 'start' || action?.action === 'resume')) {
                                                                            const start = new Date(action.time).getTime();

                                                                            if (next && (next?.action === 'pause' || next?.action === 'stop')) {
                                                                                const stop = new Date(next?.time).getTime();
                                                                                totalElapsed += Math.floor((stop - start) / 1000);
                                                                            } else {
                                                                                totalElapsed += Math.floor((Date.now() - start) / 1000);
                                                                            }
                                                                        }
                                                                    }
                                                                    const h = String(Math.floor(totalElapsed / 3600)).padStart(2, '0');
                                                                    const m = String(Math.floor((totalElapsed % 3600) / 60)).padStart(2, '0');
                                                                    const s = String(totalElapsed % 60).padStart(2, '0');
                                                                    const formattedTime = `${h}:${m}:${s}`;
                                                                    return (
                                                                        <>
                                                                            <button type="submit" className="btn-timer" style={{
                                                                                border: 'none',
                                                                                borderRadius: '10px',
                                                                                padding: '5px 10px'
                                                                            }}>
                                                                                {loading[timer?.[0]?.id] ? (
                                                                                    <Spinner
                                                                                        as="span"
                                                                                        animation="border"
                                                                                        className="custom-spinner"
                                                                                        role="status"
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                ) : (
                                                                                    <div className='timer-content'>
                                                                                        <FaClock className='me-2' />
                                                                                        {formattedTime}
                                                                                    </div>
                                                                                )}
                                                                            </button>
                                                                        </>
                                                                    )
                                                                })()}
                                                            </>
                                                        )}
                                                </div>
                                            )
                                        }
                                        )}
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Short Code</h6>
                                        </div>
                                        <div className="col-9">
                                            <h6 className="labels">CD_{data?.id}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Assigned By</h6>
                                        </div>
                                        <div className="col-9">
                                            {data?.assignedBy ? (

                                                <div className="profile-section">
                                                    {data?.assignedBy?.profile_pic ? (
                                                        <img src={`data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(data?.assignedBy?.profile_pic?.data)))}`} alt="Profile Pic" className="task-pic" />
                                                    ) : (
                                                        <UserAvatar size="40" name={data?.assignedBy?.name || 'U'} src={data?.assignedBy?.src} className="task-pic" style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                                    )}

                                                    <div className="profile-info">
                                                        <h6 className="labels">{data?.assignedBy?.name}</h6>
                                                        <h6 className="labels">{data?.assignedBy?.designation?.name}</h6>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="profile-section">
                                                    <div className="profile-info">
                                                        <h6 className="labels">--</h6>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Label</h6>
                                        </div>
                                        <div className="col-9">
                                            <h6 className="labels">{data?.label?.label_name || '--'}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Task Category</h6>
                                        </div>
                                        <div className="col-9">
                                            <h6 className="labels">{data?.task_category?.category_name || '--'}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className="labels">Description</h6>
                                        </div>
                                        <div className="col-9">
                                            <div className="labels" dangerouslySetInnerHTML={{ __html: data?.description }}></div>
                                        </div>
                                    </div>

                                    {data?.parent_task_id && (
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className="labels">Parent Task</h6>
                                            </div>
                                            <div className="col-9">
                                                <Link to='/project/employeeproject/view/task/view' state={{ data: parentTaskStateData, from: location.pathname }}>
                                                    {parentTask?.title}
                                                </Link>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-3">
                    <div className="left-part">
                        <div className="custom-row">
                            <div className="task-detail">
                                <h5 className="task-detail-divider"> Doing </h5>
                                <div className="row">
                                    <div className="input-groups">
                                        <div className="col-6">
                                            <h6 className="labels">Start Date</h6>
                                        </div>
                                        <div className="col-6">
                                            <h6 className="labels">{data?.start_date?.split(" ")[0] || '--'}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-6">
                                            <h6 className="labels">Due Date</h6>
                                        </div>
                                        <div className="col-6">
                                            <h6 className="labels">{data?.due_date?.split(" ")[0] || '--'}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-6">
                                            <h6 className="labels">Hours Logged</h6>
                                        </div>
                                        <div className="col-6">
                                            <h6 className="labels">{data?.totalHoursLogged || '--'}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="content-part">
            <div className="row">
                <div className="col-lg-9">
                    <div className="left-part">
                        <div className="custom-row">
                            <div className="project-detail">
                                <div className="viewtask-tab-buttons">
                                    <div
                                        className={`viewtask-tab-item ${activeTab === 'files' ? 'active-tab' : ''
                                            }`}
                                    >
                                        <button
                                            className="viewtask-tab-link"
                                            onClick={() => setActiveTab('files')}
                                        >
                                            Files
                                        </button>
                                    </div>

                                    <div
                                        className={`viewtask-tab-item ${activeTab === 'subtask' ? 'active-tab' : ''
                                            }`}
                                    >
                                        <button
                                            className="viewtask-tab-link"
                                            onClick={() => setActiveTab('subtask')}
                                        >
                                            Sub Task
                                        </button>
                                    </div>

                                    <div
                                        className={`viewtask-tab-item ${activeTab === 'comment' ? 'active-tab' : ''
                                            }`}
                                    >
                                        <button
                                            className="viewtask-tab-link"
                                            onClick={() => setActiveTab('comment')}
                                        >
                                            Comment
                                        </button>
                                    </div>

                                    <div
                                        className={`viewtask-tab-item ${activeTab === 'timesheet' ? 'active-tab' : ''
                                            }`}
                                    >
                                        <button
                                            className="viewtask-tab-link"
                                            onClick={() => setActiveTab('timesheet')}
                                        >
                                            Timesheet
                                        </button>
                                    </div>

                                    <div
                                        className={`viewtask-tab-item ${activeTab === 'notes' ? 'active-tab' : ''
                                            }`}
                                    >
                                        <button
                                            className="viewtask-tab-link"
                                            onClick={() => setActiveTab('notes')}
                                        >
                                            Notes
                                        </button>
                                    </div>

                                    <div
                                        className={`viewtask-tab-item ${activeTab === 'history' ? 'active-tab' : ''
                                            }`}
                                    >
                                        <button
                                            className="viewtask-tab-link"
                                            onClick={() => setActiveTab('history')}
                                        >
                                            History
                                        </button>
                                    </div>

                                </div>

                                {activeTab === 'files' && (
                                    <>
                                        <div className='subtask-row'>
                                            <div className='d-flex flex-row justify-content-between'>
                                                <div className="add-sub-task" onClick={fileInput}>
                                                    <LuPlusCircle className='fs-5' />
                                                    <h6 className="ms-2 mt-2">Upload File</h6>
                                                </div>

                                                {previews?.length > 0 &&
                                                    <div className="edit-btn">
                                                        <button
                                                            type="submit"
                                                            className="custom-btn"
                                                            onClick={handleSaveFile}
                                                        >{props?.loading ? <Spinner as="span" animation="border" className="custom-spinner" role="status" aria-hidden="true" /> : "Save"}</button>
                                                    </div>
                                                }
                                            </div>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={fileChange}
                                            />
                                        </div>


                                        {previews.length > 0 &&
                                            <div className="preview" style={{ marginTop: "20px" }}>
                                                {previews.map((preview, index) => (
                                                    <div key={index} className="preview-item">
                                                        {files[index].type.startsWith('application/pdf') ? (
                                                            <div className='preview-pdf'>
                                                                <div style={{ display: 'flex' }}>
                                                                    <img src={Pdf} alt="" style={{ width: "100px", height: "100px" }} className='preview-image' />
                                                                    <div className="remove-icon" onClick={() => handleRemoveFile(index)}>
                                                                        <IoClose />
                                                                    </div>
                                                                </div>
                                                                <div className='preview-text mt-2'>
                                                                    <span className='text-center '>
                                                                        {files[index].name}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="preview-image-wrapper">
                                                                <div style={{ display: 'flex' }}>
                                                                    <img src={preview} alt={`File preview ${index}`} style={{ width: '600px', height: '500px' }} className='preview-image' />
                                                                    <div className="remove-icon" onClick={() => handleRemoveFile(index)}>
                                                                        <IoClose />
                                                                    </div>
                                                                </div>
                                                                <div className='preview-text ' style={{ marginBottom: "20px" }}>
                                                                    <span className='text-center '>
                                                                        {files[index].name}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        }

                                        <div className='files'>
                                            {(uploadedFiles?.length > 0 || files.length > 0) && <h4 className='mt-5'>Uploaded Files</h4>}

                                            {(uploadedFiles?.length > 0 || files.length > 0) ? uploadedFiles.map((item, index) => {
                                                let icon = null;
                                                let title = '';
                                                console.log(item)

                                                switch (item?.mimeType) {
                                                    case 'application/pdf':
                                                        icon = Pdf;
                                                        title = 'PDF';
                                                        break;
                                                    case 'image/png':
                                                        icon = PNGIcon;
                                                        title = 'PNG';
                                                        break;
                                                    case 'image/jpeg':
                                                        icon = JPGIcon;
                                                        title = 'JPEG';
                                                        break;
                                                    default:
                                                        return null;
                                                }

                                                return (
                                                    <div key={index} className='preview-item d-flex'>
                                                        <img
                                                            src={icon}
                                                            width="20%"
                                                            height="100%"
                                                            title={title}
                                                            className='col-lg-1'
                                                            style={{ position: 'relative', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                setParticularItem(item);
                                                                setShow(true)
                                                            }}
                                                        />
                                                        <div
                                                            className='col-lg-3'
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                setParticularItem(item);
                                                                setShow(true)
                                                            }}>{item?.file_name}</div>
                                                        <IoTrash size={20} className='col-lg-3' color='red'
                                                            style={{ position: 'relative', marginLeft: '20px', cursor: 'pointer' }}
                                                            onClick={() => handleDeleteFile(item)} />
                                                    </div>
                                                );
                                            }) : (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        minHeight: '150px',
                                                        color: 'gray',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <FaFile size={20} />
                                                    <p style={{ marginTop: 10 }}>- No file uploaded. -</p>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}

                                {activeTab === 'subtask' && (
                                    <div className='subtask-row'>

                                        {(!showInput ? (
                                            <>
                                                <div className="add-sub-task mb-2" onClick={showFields}>
                                                    <LuPlusCircle className='fs-5' />
                                                    <h6 className="ms-2 mt-2">Add Sub Task</h6>
                                                </div>
                                                {subTaskData?.length == 0 && (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            minHeight: '150px',
                                                            color: 'gray',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <FaListCheck size={20} />
                                                        <p style={{ marginTop: 10 }}>- Seems like no sub task exists in the database. Please create the sub task first -</p>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <h6 className='label'>Title</h6>
                                                        <input type="text" className="input-css" name='title' placeholder="Enter a task title" value={clientData?.title}
                                                            onChange={(e) => {
                                                                setClientData((preVal) => ({
                                                                    ...preVal,
                                                                    title: e.target.value
                                                                }))
                                                            }} />
                                                    </div>
                                                </div>

                                                <div className="col-lg-4">
                                                    <div className="input-group">
                                                        <h6 className='label'>Start Date</h6>
                                                        <DatePicker
                                                            selected={clientData.startdate ? new Date(clientData.startdate) : null}
                                                            onChange={(date) => {
                                                                const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                                setClientData((preVal) => ({
                                                                    ...preVal,
                                                                    startdate: localDate,
                                                                }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            name="transaction_date"
                                                            disabled={props.loading}
                                                            customInput={<input className="input-css" />}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: "#5757fe",
                                                                    primary: "#5757fe",
                                                                },
                                                            })}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-4">
                                                    <div className="input-group">
                                                        <h6 className='label'>End Date</h6>
                                                        <DatePicker
                                                            selected={clientData.enddate ? new Date(clientData.enddate) : null}
                                                            onChange={(date) => {
                                                                const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                                setClientData((preVal) => ({
                                                                    ...preVal,
                                                                    enddate: localDate,
                                                                }));
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            name="transaction_date"
                                                            disabled={props.loading}
                                                            customInput={<input className="input-css" />}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: "#5757fe",
                                                                    primary: "#5757fe",
                                                                },
                                                            })}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-4">
                                                    <div className="input-group">
                                                        <h6 className='label'>Assign To</h6>
                                                        <Select
                                                            options={AssignTo}
                                                            styles={{
                                                                ...customStyle,
                                                                menu: (provided) => ({
                                                                    ...provided,
                                                                    zIndex: 2,
                                                                }),
                                                            }}
                                                            value={clientData.assignto}
                                                            placeholder="---"
                                                            onChange={(val) => {
                                                                setClientData((preVal) => ({
                                                                    ...preVal,
                                                                    assignto: val
                                                                }))
                                                            }}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: "#5757fe",
                                                                    primary: "#5757fe",
                                                                },
                                                            })}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <h6 className="label">Description</h6>
                                                        <textarea
                                                            rows="4"
                                                            cols="50"
                                                            className="form-control input-css"
                                                            style={{ width: '100%' }}
                                                            name="address"
                                                            placeholder="Description"
                                                            value={clientData?.description}
                                                            onChange={(e) => {
                                                                setClientData((preVal) => ({
                                                                    ...preVal,
                                                                    description: e.target.value
                                                                }))
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="edit-btn d-flex justify-content-end">
                                                    <button
                                                        type="submit"
                                                        className="btn-cancel"
                                                        onClick={hideFields}
                                                    >
                                                        {props.loading ? (
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                className="custom-spinner"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        ) : (
                                                            "Cancel"
                                                        )}
                                                    </button>

                                                    <button
                                                        type="submit"
                                                        className="custom-btn"
                                                        onClick={handleSubmit}
                                                    >
                                                        {props.loading ? (
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                className="custom-spinner"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        ) : (
                                                            "Submit"
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                        )}
                                        {!showInput && subTaskData?.length > 0 && (
                                            <Table
                                                header={subTaskHeader}
                                                data={subTaskData}
                                                footer={footer}
                                                count={subTaskData?.length}
                                                records={subTaskData?.length}
                                                handleChange={handleChange}
                                                loading={props.loading}
                                            />
                                        )}


                                    </div>
                                )}

                                {activeTab === 'comment' && (
                                    <>
                                        <div className='subtask-row'>
                                            <div className="add-sub-task">
                                                <LuPlusCircle className='fs-5' />
                                                <h6 className="ms-2 mt-2">Add Comment</h6>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                minHeight: '150px',
                                                color: 'gray',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <FaCommentAlt size={20} />
                                            <p style={{ marginTop: 10 }}>- No comment found. -</p>
                                        </div>
                                    </>
                                )}

                                {activeTab === 'timesheet' && (
                                    <div className='timesheet-row'>
                                        <div className="invoice-table-part">
                                            <Table
                                                header={header}
                                                data={inData}
                                                footer={footer}
                                                count={count}
                                                records={count}
                                                loading={props.loading}
                                            />
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'notes' && (
                                    <>
                                        <div className='subtask-row'>
                                            <div className="add-sub-task">
                                                <LuPlusCircle className='fs-5' />
                                                <h6 className="ms-2 mt-2">Add Note</h6>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                minHeight: '150px',
                                                color: 'gray',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <FaClipboard size={20} />
                                            <p style={{ marginTop: 10 }}>- No note found. -</p>
                                        </div>
                                    </>
                                )}

                                {activeTab === 'history' && (
                                    <div className='history-row'>
                                        {data?.taskTimerMap?.map((timerItem, index) => {
                                            const history = JSON.parse(timerItem.action_history || '[]');
                                            const sortedHistory = history.sort((a, b) => new Date(b.time) - new Date(a.time));

                                            return sortedHistory.map((entry, subIndex) => (
                                                <div key={`${index}-${subIndex}`} className="input-groups">
                                                    <div className="col-1">
                                                        {timerItem?.user?.profile_pic?.data ? (

                                                            <img src={`data:image/jpeg;base64,${btoa(
                                                                new Uint8Array(timerItem?.user?.profile_pic?.data).reduce(
                                                                    (data, byte) => data + String.fromCharCode(byte),
                                                                    ''
                                                                )
                                                            )}`} className="task-history-image" />
                                                        ) : (
                                                            <UserAvatar name={timerItem?.user?.name} size={40} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                                                        )}
                                                    </div>
                                                    <div className="col-11">
                                                        <h6 className="labels-heading">
                                                            Timer {entry.action.charAt(0).toUpperCase() + entry.action.slice(1)} {timerItem?.user?.name}
                                                        </h6>
                                                        <h6 className="labels">
                                                            {new Date(entry.time.replace(' ', 'T')).toLocaleString('en-GB', {
                                                                day: '2-digit',
                                                                month: '2-digit',
                                                                year: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true,
                                                                formatMatcher: 'basic'
                                                            })}
                                                        </h6>
                                                    </div>
                                                </div>
                                            ));
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            show={show}
            onHide={handleClose}
            centered
            aria-labelledby="contained-modal-title-vcenter"
            size='lg'
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    View File
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid details-model">
                <Container>
                    <Row className='mb-3'>
                        <Col lg={12} md={12}>
                            <strong>{particularItem?.file_name}</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={12} className="d-flex justify-content-center">
                            {particularItem?.mimeType?.startsWith('image/') ? (
                                <iframe
                                    src={particularItem?.url}
                                    width='100%'
                                    height='350px'
                                />
                            ) : (
                                <iframe
                                    src={particularItem?.url}
                                    width="100%"
                                    height="500px"
                                    title={particularItem?.name}
                                ></iframe>
                            )}
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    </div>

    return (
        <>
            {content}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.taskReducer.loading,
        task: state.taskReducer.task,
        timesheet: state.timesheetReducer.timesheet,
        user: state.authenticationReducer.user,
        taskFiles: state.taskReducer.taskFiles,
        users: state.userReducer.users,
        subTask: state.taskReducer.subTask,
        updateTaskTimerData: state.taskReducer.updateTask

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTasks: () => {
            dispatch(getTasks());
        },
        updateTask: (id, data, showToast) => {
            dispatch(updateTask(id, data, showToast));
        },
        // getTimesheets: () => {
        //     dispatch(getTimesheets())
        // },
        getTaskFiles: () => {
            dispatch(getTaskFiles())
        },
        addTaskFiles: (data) => {
            dispatch(addTaskFiles(data))
        },
        updateTaskFiles: (id, data, showToast) => {
            dispatch(updateTaskFiles(id, data, showToast))
        },
        deleteTaskFiles: (id) => {
            dispatch(deleteTaskFiles(id))
        },
        getUsers: (options) => {
            dispatch(getUsers(options))
        },
        getSubTaskList: () => {
            dispatch(getSubTaskList())
        },
        addSubTask: (data) => {
            dispatch(addSubTask(data))
        },
        updateSubTask: (id, data, showToast) => {
            dispatch(updateSubTask(id, data, showToast))
        },
        deleteSubTask: (id) => {
            dispatch(deleteSubTask(id))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmpTask);